import react, { useEffect, useState } from "react";
import MenuEmpresas from "./menuempresas";
import axios from "axios";
import { useLocation } from "react-router-dom";
import Box from "@mui/joy/Box";
import AspectRatio from "@mui/joy/AspectRatio";
import { Typography } from "@mui/joy";
import DescriptionIcon from "@mui/icons-material/Description";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Button from "@mui/joy/Button";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PublicIcon from "@mui/icons-material/Public";
import LayersIcon from "@mui/icons-material/Layers";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Avatar from "@mui/joy/Avatar";
import AvatarGroup from "@mui/joy/AvatarGroup";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import Divider from "@mui/joy/Divider";
import Table from "@mui/joy/Table";
import Sheet from "@mui/joy/Sheet";

export default function DetalleAventura() {
  let { state } = useLocation();
  let infoRecibida = state?.x;
  console.log(infoRecibida);
  let fechaFormato = new Date(infoRecibida.fecha);
  let [participantes, setParticipantes] = react.useState();

  {
    useEffect(() => {
      let getInformacion = async () => {
        try {
          let token = localStorage.getItem("token");

          let getParticipantes = await axios.get(
            `${process.env.REACT_APP_FRONTEND_URL}/api/aventura/usuarios-inscritos?id=${infoRecibida.id_actividad}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );

          setParticipantes(getParticipantes.data);
          console.log(participantes);
        } catch (err) {
          console.log(
            "No es posible obtener a los participantes de la Aventura: " + err
          );
        }
      };
      getInformacion();
    }, []);
  }

  let Body = () => {
    return (
      <Box
        sx={{
          display: "flex",
          width: "100vw",
          marginLeft: 10,
          height: "100vh",
        }}
      >
        <Box sx={{ width: "50%", padding: 5 }}>
          <Box>
            <AspectRatio ratio="2">
              <img
                src={`${process.env.REACT_APP_DOSPACES}/uploads/${infoRecibida.imagen}`}
                alt=""
                style={{ borderRadius: 5 }}
              />
            </AspectRatio>
          </Box>
          <Box sx={{ marginTop: 3 }}>
            <Typography level="title-lg">{infoRecibida.titulo}</Typography>
          </Box>
          <Box
            sx={{
              backgroundColor: "#f0f4f8",
              borderRadius: 5,
              marginTop: 2,
              padding: 3,
              display: "grid",
              gap: 1,
            }}
          >
            <Typography
              level="title-sm"
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <DescriptionIcon fontSize="inherit" />
              Descripción de la Aventura
            </Typography>
            <Typography level="body-sm">{infoRecibida.descripcion}</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              marginTop: 3,
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <LocationOnIcon fontSize="inherit" />
                Punto de encuentro
              </Typography>
              <Typography level="body-sm">
                {infoRecibida.punto_de_encuentro}
              </Typography>
            </Box>
            <Box>
              <Button
                color="neutral"
                variant="soft"
                size="md"
                onClick={() => {
                  window.open(
                    `https://www.google.com/maps?q=${infoRecibida.latitud},${infoRecibida.longitud}`
                  );
                }}
              >
                Ver en Maps
              </Button>
            </Box>
          </Box>
          <Box sx={{ marginTop: 3, display: "flex", width: "100%", gap: 1 }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <ScheduleIcon fontSize="inherit" />
                Fecha de Ejecución
              </Typography>
              <Typography level="body-sm">
                {fechaFormato.toLocaleDateString("es-ES", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                  timeZone: "UTC",
                })}
              </Typography>
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <PublicIcon fontSize="inherit" />
                Ubicación
              </Typography>
              <Typography level="body-sm">
                {infoRecibida.pais}, {infoRecibida.ciudad}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ marginTop: 3, display: "flex", width: "100%", gap: 1 }}>
            <Box sx={{ width: "50%" }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <LayersIcon fontSize="inherit" />
                Categoría
              </Typography>
              <Typography level="body-sm">
                {infoRecibida.nombre_categoria}
              </Typography>
            </Box>
            <Box sx={{ width: "50%" }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <PriorityHighIcon fontSize="inherit" />
                Nivel
              </Typography>
              <Typography level="body-sm">
                {infoRecibida.nombre_nivel}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ width: "50%", padding: 5 }}>
          <Box sx={{ width: "100%" }}>
            <Typography
              level="title-lg"
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              Participantes
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: 3,
              display: "flex",
              gap: 1,
              backgroundColor: "#f0f4f8",
              borderRadius: 5,
              marginTop: 2,
              padding: 3,
            }}
          >
            <Box sx={{ width: "50%" }}>
              <Typography
                level="title-sm"
                sx={{
                  display: "flex",
                  gap: 0.5,
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <EmojiPeopleIcon fontSize="inherit" />
                Total Inscritos
              </Typography>
              <Typography level="body-sm">
                {participantes ? participantes.usuariosinscritos.length : null}
              </Typography>
            </Box>
            <AvatarGroup>{participantes ? inscritos() : null}</AvatarGroup>
          </Box>
          <Box sx={{ width: "100%", marginTop: 3 }}>
            <Typography
              level="title-lg"
              sx={{
                display: "flex",
                gap: 0.5,
                alignItems: "center",
                alignContent: "center",
              }}
            >
              Pagos Recibidos
            </Typography>
          </Box>
          <Box sx={{ width: "100%", marginTop: 3 }}>
            {participantes ? pagosRecibidos2() : null}
          </Box>
        </Box>
      </Box>
    );
  };

  function pagosRecibidos() {
    return (
      <Box
        sx={{
          backgroundColor: "#f0f4f8",
          borderRadius: 5,
          display: "flex",
          gap: 1,
        }}
      >
        <Box>
          <AspectRatio ratio={0.8} sx={{ width: 50 }}>
            <img
              src={`${process.env.REACT_APP_DOSPACES}/uploads/${infoRecibida.imagen}`}
              alt=""
              style={{ borderTopLeftRadius: 5, borderBottomLeftRadius: 5 }}
            />
          </AspectRatio>
        </Box>
        <Box sx={{ paddingLeft: 1, paddingTop: 1 }}>
          <Typography level="title-md" fontSize={14}>
            Nombre
          </Typography>
          <Typography level="body-xs">Diego Rosas</Typography>
        </Box>
        <Divider orientation="vertical" />
        <Box sx={{ paddingLeft: 1, paddingTop: 1 }}>
          <Typography level="title-md" fontSize={14}>
            Teléfono
          </Typography>
          <Typography level="body-xs">+56973060643</Typography>
        </Box>
        <Divider orientation="vertical" />
        <Box sx={{ paddingLeft: 1, paddingTop: 1 }}>
          <Typography level="title-md" fontSize={14}>
            Monto Pagado
          </Typography>
          <Typography level="body-xs">$20.000 CLP</Typography>
        </Box>
        <Divider orientation="vertical" />
        <Box sx={{ paddingLeft: 1, paddingTop: 1 }}>
          <Typography level="title-md" fontSize={14}>
            A Depositar
          </Typography>
          <Typography level="body-xs">$15.000 CLP</Typography>
        </Box>
        <Divider orientation="vertical" />
        <Button variant="soft">Ver detalle</Button>
      </Box>
    );
  }
  function pagosRecibidos2() {
    return (
      <Sheet variant="outlined" sx={{ borderRadius: 5 }}>
        <Table>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Teléfono</th>
              <th>Monto Pagado</th>
              <th>Costo Servicio</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Diego Rosas</td>
              <td>+56973060643</td>
              <td>$20.000 CLP</td>
              <td>Costo Servicio</td>
              <td>$15.000 CLP</td>
            </tr>
            <tr>
              <td>Diego Rosas</td>
              <td>+56973060643</td>
              <td>$20.000 CLP</td>
              <td>Costo Servicio</td>
              <td>$15.000 CLP</td>
            </tr>
            <tr>
              <td>Diego Rosas</td>
              <td>+56973060643</td>
              <td>$20.000 CLP</td>
              <td>Costo Servicio</td>
              <td>$15.000 CLP</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={5} style={{ textAlign: "right" }}>
                Total: $50.000 CLP
              </th>
            </tr>
          </tfoot>
        </Table>
      </Sheet>
    );
  }

  function inscritos() {
    return (
      <Box sx={{ width: "50%", display: "flex" }}>
        {participantes.usuariosinscritos.map((x, index) => {
          if (index > 5) {
            return null;
          } else if (index < 5) {
            return (
              <Avatar
                src={`${process.env.REACT_APP_DOSPACES}/uploads/${x.foto_de_perfil}`}
                size="md"
              />
            );
          }
        })}
      </Box>
    );
  }

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          alignContent: "center",
          justifyContent: "center",
        }}
      >
        <Body />
        <MenuEmpresas />
      </Box>
    </Box>
  );
}
